import React from 'react';

var Clear = (function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#AAA7B0' : _ref$color,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '24' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '24' : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 110 18 9 9 0 010-18zM8.705 7.292a.999.999 0 10-1.413 1.413L10.588 12l-3.296 3.295a.999.999 0 101.413 1.413L12 13.412l3.295 3.296a.999.999 0 001.413-1.413L13.412 12l3.296-3.295a.999.999 0 00-1.413-1.413L12 10.588z",
    fill: color,
    fillRule: "evenodd"
  }));
});

export { Clear as default };
//# sourceMappingURL=clear.js.map
